import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=c0b1d8dc&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=c0b1d8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b1d8dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0b1d8dc')) {
      api.createRecord('c0b1d8dc', component.options)
    } else {
      api.reload('c0b1d8dc', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=c0b1d8dc&scoped=true&", function () {
      api.rerender('c0b1d8dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24dGlewkPm8C3/JS/comp/Voucher.vue"
export default component.exports